import storage from '@api/storage';
import { FromDateParams, PaginationParams, TranslateData } from '@customTypes/Api';
import { Email, EmailTemplate, Form, LandingPage, LandingPageTemplate, Languages, Program, Snippet } from '@customTypes/Entities';
import axios from 'axios';

const instance = axios.create({ baseURL: process.env.REACT_APP_API_URL });

class Api {
  getToken() {
    return storage.token;
  }

  getAuthHeaders() {
    return { 'x-api-key': this.getToken() };
  }

  async getPrograms(params?: PaginationParams & FromDateParams): Promise<Program[]> {
    try {
      const { data } = await instance.get('/programs', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translatePrograms(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/programs', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getEmailTemplates(params?: PaginationParams): Promise<EmailTemplate[]> {
    try {
      const { data } = await instance.get('/email-templates', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translateEmailTemplates(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/email-templates', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getEmails(params?: PaginationParams): Promise<Email[]> {
    try {
      const { data } = await instance.get('/emails', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translateEmails(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/emails', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getForms(params?: PaginationParams): Promise<Form[]> {
    try {
      const { data } = await instance.get('/forms', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translateForms(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/forms', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getLandingPageTemplates(params?: PaginationParams): Promise<LandingPageTemplate[]> {
    try {
      const { data } = await instance.get('/landing-page-templates', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translateLandingPageTemplates(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/landing-page-templates', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getLandingPages(params?: PaginationParams): Promise<LandingPage[]> {
    try {
      const { data } = await instance.get('/landing-pages', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translateLandingPages(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/landing-pages', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getSnippets(params?: PaginationParams): Promise<Snippet[]> {
    try {
      const { data } = await instance.get('/snippets', { headers: this.getAuthHeaders(), ...(params && { params }) });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async translateSnippets(data: TranslateData): Promise<void> {
    try {
      await instance.post('/translate/snippets', data, { headers: this.getAuthHeaders() });
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getLanguages(): Promise<Languages> {
    try {
      const { data } = await instance.get('/languages', { headers: this.getAuthHeaders() });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async getStatus(): Promise<any> {
    try {
      const { data } = await instance.get('/status', { headers: this.getAuthHeaders() });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }

  async verifyCustomer(token: string): Promise<any> {
    try {
      const { data } = await instance.get(`/me`, { headers: { 'x-api-key': token } });
      return data;
    } catch (err) {
      console.error(err);
      throw err;
    }
  }
}

export default new Api();
